import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as pageAction from './../../../../../actions/pageAction';
import RatingDetail from './RatingDetail';

const mapStateToProps = state => {
    return {
        // postState: state.postReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        // getPostDetail: (id) => dispatch(postAction.getPostDetail(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RatingDetail));
